import React from 'react';

function Block(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M11.9983 2C6.47564 2 1.99832 6.47732 1.99832 12C1.99832 14.7563 3.11354 17.2521 4.91734 19.061C4.92059 19.0644 4.92388 19.0678 4.92723 19.0711C4.93056 19.0745 4.93392 19.0777 4.93731 19.081C6.74618 20.8848 9.24206 22 11.9983 22C17.521 22 21.9983 17.5227 21.9983 12C21.9983 6.47732 17.521 2 11.9983 2ZM6.26883 18.6133C7.80393 19.9444 9.80709 20.75 11.9983 20.75C16.8306 20.75 20.7483 16.8323 20.7483 12C20.7483 9.80857 19.9426 7.80524 18.6113 6.2701L6.26883 18.6133ZM17.7274 5.38627C16.1923 4.0554 14.1893 3.25 11.9983 3.25C7.166 3.25 3.24832 7.16768 3.24832 12C3.24832 14.1912 4.05386 16.1944 5.38495 17.7295L17.7274 5.38627Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default Block;
